export default __webpack_public_path__ + "static/media/turn-on.1984dfa7.svg";